import {
  allSmartCallFlowActionTypes,
  type ISmartCallFlowActionType,
} from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/type'
import { type SmartCallFlowBuilderStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder'

export const getActions = ({
  getActionById,
  source,
  target,
}: {
  getActionById: SmartCallFlowBuilderStore['getActionById']
  source: string
  target: string
}): ISmartCallFlowActionType[] => {
  const sourceStore = getActionById(source)?.actionStore
  const targetStore = getActionById(target)?.actionStore

  const branchAllowed =
    (sourceStore?.nextIds.length ?? 0) > 1
      ? sourceStore?.allowedNextActionsByBranchIndex?.[sourceStore.nextIds.indexOf(target)]
      : undefined
  const allowedNext = branchAllowed ?? sourceStore?.allowedNextActions

  return allSmartCallFlowActionTypes.filter(
    (type) =>
      (!allowedNext || allowedNext.includes(type)) &&
      (!targetStore?.allowedBeforeActions || targetStore.allowedBeforeActions.includes(type))
  )
}
